module.exports = __webpack_public_path__ + "static/media/4.0ba8ef7a.jpg";